function showVideoCatalogMountainsTotalNumber(){
    if(videoCatalogMountainsData != undefined && videoCatalogMountainsData != null){
        $('.js-video-catalog-mountains-number').text(videoCatalogMountainsData.length);
    }
}

runIfElementExist(showVideoCatalogMountainsTotalNumber, '.js-video-catalog-mountains-number');


function showVideoCatalogTeamsTotalNumber(){
    if(videoCatalogTeamsData != undefined && videoCatalogTeamsData != null){
        $('.js-video-catalog-teams-number').text(videoCatalogTeamsData.length);
    }
}

runIfElementExist(showVideoCatalogTeamsTotalNumber, '.js-video-catalog-teams-number');
